(function () {

  'use strict';

  angular.module('sempraWebapp').service('webSocketMock', webSocketMock);

  /** @ngInject */
  function webSocketMock() {

    this.initWebSockets = function () {
    };

    this.unsubscribeSocket = function () {
    };

    this.suspendMessages = function () {
    };

    this.isSuspended = function () {
    };

    this.isConnected = function () {
    };

    this.subscribeToTopic = function () {
    };
  }
})();

